<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Participants
      </h2>
    </div>

    <!-- <div v-if="hasMissingDocuments" class="col-12 white-bg flex items-center mb2">
      <i class="icon icon-attention h3 right-0 top-0 mx1 mt1 red"></i>
      <span class="red">Un justificatif pour ce tarif vous sera demandé lors de votre entrée.</span>
    </div> -->

    <div class="flex flex-wrap">
      <div v-if="multipleParticipantsAllowed" class="col-3 sm-col-6 flex justify-center mb3 px2">
        <div class="card dashed-border col-12 pointer flex items-center" @click="handleAddParticipant">
          <div class="col-12 center">
            <i class="icon h1 icon-plus mt2"></i>
            <p class="mx1 h3 break-word">Ajouter un participant</p>
          </div>
        </div>
      </div>
      <ParticipantCard v-for="(participant, index) in participantsAdded" :key="index" :participant="participant" />
    </div>

    <div class="flex flex-wrap">
      <div class="col-12 py2 flex justify-end items-center">
        <Button class="col-12 sm-col-12 md-col-4 ml2" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" id="button-confirm-submit-participants" class="col-12 sm-col-12 md-col-4 ml2" :disabled="!participantsAdded.length" :action="confirmSubmitParticipants" text="Suivant" />
        <Button v-else class="col-12 sm-col-12 md-col-4 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/elements/Button';
import ParticipantCard from '../../components/participants/ParticipantCard';

import { changeToPage, confirmParticipants, validatePreReservationParticipants } from '@/utils/logics';

export default {
  components: {
    Button,
    ParticipantCard
  },
  data () {
    return {
      participantsAdded: this.$store.state.cartItem ? this.$store.state.cartItem.participants : [],
      cartItem: this.$store.state.cartItem,
      offerInfo: this.$store.state.offerInfo,
      loading: false,
      product: this.$store.state.product
    };
  },
  computed: {
    multipleParticipantsAllowed () {
      if (!this.participantsAdded.length) {
        return true;
      }

      if (process.env.VUE_APP_ENVIRONMENT === 'production') {
        if (this.offerInfo.detail.recurring) {
          return false;
        }
      }

      if ((this.offerInfo.detail.activities || []).some(a => a.activity_type === 'TERRAIN' || a.activity_type === 'POSTE')) {
        return false;
      }

      if ((this.product.areas || []).some(area => area.name === 'Raquettes')) {
        return false;
      }

      return true;
    },
    isReservation () {
      return this.offerInfo.detail.reservation || this.offerInfo.detail.inscription;
    },
    hasMissingDocuments () {
      if (!this.cartItem?.participants?.length) {
        return false;
      }
      return this.cartItem.participants.some(p => {
        const docs = p.tariff?.documents;
        return docs != null && !docs.validInfo;
      });
    }
  },
  methods: {
    changeToPage,
    async confirmSubmitParticipants () {
      this.loading = true;

      const { preReservationOrder } = this.$store.state;
      if (preReservationOrder && preReservationOrder.orderGeneric && preReservationOrder.session) {
        const orderItems = preReservationOrder.orderGeneric.order?.order_items || [];
        const preReservationSession = preReservationOrder.session;
        const participants = this.cartItem.participants || [];

        if (preReservationSession && participants.length > 0) {
          const { matchCount, allMatch } = await validatePreReservationParticipants(participants, orderItems, preReservationSession);

          if (matchCount > 0) {
            this.$store.commit('setPreReservationOrder', { ...preReservationOrder, excludeResumeOrder: !allMatch });
            this.$store.commit('setPage', 'Participants');
            this.changeToPage('ResumeOrder');
            this.loading = false;
            return;
          }
        }
      }

      await confirmParticipants();
      this.loading = false;
    },
    handleAddParticipant () {
      this.changeToPage('AddParticipant');
    },
    handleBack () {
      this.changeToPage('Configure');
    }
  }
};
</script>

<style lang="scss">
  .dashed-border {
    border: 2px dashed #ccc;
  }

  .card {
    height: 220px;
    max-width: 10rem;
    color: #666;
    border-radius: 10px;
  }
</style>
